export const SUPPORTED_LOCALES = ['zh', 'ja']
export const LOCALE_STORAGE_KEY = 'app_locale'

let activeRouteLocale = null

export function isSupportedLocale (v) {
  return SUPPORTED_LOCALES.includes(v)
}

export function getStoredLocale () {
  try {
    const v = localStorage.getItem(LOCALE_STORAGE_KEY)
    if (isSupportedLocale(v)) return v
  } catch (e) { /* ignore */ }
  return null
}

export function setStoredLocale (locale) {
  if (!isSupportedLocale(locale)) return
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale)
  } catch (e) { /* ignore */ }
}

function detectBrowserLocale () {
  if (typeof navigator === 'undefined') return 'zh'
  const lang = (navigator.language || '').toLowerCase()
  return lang.startsWith('ja') ? 'ja' : 'zh'
}

/** 无 URL 时：localStorage → 浏览器语言 → 默认中文 */
export function getPreferredLocale () {
  return getStoredLocale() || detectBrowserLocale()
}

export function setActiveRouteLocale (locale) {
  activeRouteLocale = isSupportedLocale(locale) ? locale : null
}

export function getActiveRouteLocale () {
  return activeRouteLocale || getPreferredLocale()
}

/**
 * 为 C 端路径加上当前语言前缀；已含 /zh、/ja 或管理端路径则原样返回。
 */
export function prefixPath (path) {
  if (path == null || path === '') return `/${getActiveRouteLocale()}/home`
  if (typeof path !== 'string') return path
  if (/^https?:\/\//i.test(path)) return path
  if (path.startsWith('/admin')) return path
  const normalized = path.startsWith('/') ? path : `/${path}`
  if (/^\/(zh|ja)(\/|$)/.test(normalized)) return normalized
  const loc = getActiveRouteLocale()
  if (normalized === '/') return `/${loc}/home`
  return `/${loc}${normalized}`
}

/**
 * 将无前缀路径规范为带 zh/ja 的路径（用于 beforeEach）；与 prefixPath 不同，这里用「偏好」而非当前激活。
 */
export function pathWithPreferredLocale (path, locale = getPreferredLocale()) {
  if (!path || path === '/') return `/${locale}/home`
  if (path.startsWith('/admin')) return path
  const normalized = path.startsWith('/') ? path : `/${path}`
  if (/^\/(zh|ja)(\/|$)/.test(normalized)) return normalized
  return `/${locale}${normalized}`.replace(/\/+/g, '/')
}

/**
 * 去掉首段语言前缀，得到「站内相对路径」，如 /zh/m/book/1 -> /m/book/1
 */
export function stripLocalePrefix (path) {
  if (!path || typeof path !== 'string') return path
  return path.replace(/^\/(zh|ja)(?=\/|$)/, '') || '/'
}

/** 把当前路由换成另一语言，保持后半路径与 query */
export function alternateLocalePath (route, newLocale) {
  if (!isSupportedLocale(newLocale)) return route.fullPath
  const rest = stripLocalePrefix(route.path)
  const suffix = !rest || rest === '/' ? '/home' : rest
  return `/${newLocale}${suffix}`
}
